import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/tipos-cuenta`;

export const getTiposCuenta = async (token) => {
    const response = await fetch(API_URL, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de cuenta');
    return response.json();
};

export const getTipoCuentaById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) {
        const errorData = await response.text();
        console.error('Error details:', errorData);
        throw new Error('Error al obtener el tipo de cuenta: ' + errorData);
    }
    return response.json();
};

export const createTipoCuenta = async (token, data) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el tipo de cuenta');
    return response.json();
};

export const updateTipoCuenta = async (token, id, data) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el tipo de cuenta');
    return response.json();
};

export const deleteTipoCuenta = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el tipo de cuenta');
};
